import { Link } from "react-router-dom";
import { Check, Minus } from "lucide-react";
import { Progress } from "@/components/ui/progress";

export const STEPS = [
  { key: "account", title: "Owner account & email", optional: false },
  { key: "business", title: "Business details & ABN", optional: false },
  { key: "timezone", title: "Time zone & working week", optional: false },
  { key: "locations", title: "Workplace locations", optional: false },
  { key: "map", title: "Find addresses on the map", optional: true },
  { key: "geofence", title: "Geofence & clock-in policy", optional: true },
  { key: "invite", title: "Invite employees", optional: true },
  { key: "roles", title: "Roles & permissions", optional: true },
  { key: "payroll", title: "Breaks & payroll", optional: true },
  { key: "notifications", title: "Notifications", optional: true },
  { key: "plan", title: "Plan or free trial", optional: false },
  { key: "dashboard", title: "Enter your dashboard", optional: false },
];

export const stepState = (business, key) => {
  const ob = business?.onboarding || { completed: [], skipped: [] };
  if (ob.completed.includes(key) || (key === "notifications" && ob.completed.includes("dashboard"))) return "done";
  if (ob.skipped.includes(key)) return "skipped";
  return "todo";
};

export const isOnboardingComplete = (business) => STEPS.every((s) => stepState(business, s.key) === "done");

export const Checklist = ({ business, active, onSelect, compact = false }) => {
  const done = STEPS.filter((s) => stepState(business, s.key) === "done").length;
  return (
    <div data-testid="onboarding-checklist">
      <div className="flex items-center justify-between text-sm"><span className="font-semibold">Setup checklist</span><span className="font-mono-num text-slate-500" data-testid="onboarding-progress-text">{done}/{STEPS.length}</span></div>
      <Progress value={(done / STEPS.length) * 100} className="mt-2 h-2" />
      <ol className="mt-4 space-y-1">
        {STEPS.map((s, i) => {
          const st = stepState(business, s.key);
          const inner = (
            <>
              <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-[11px] font-bold ${st === "done" ? "bg-[#00A85C] text-white" : st === "skipped" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"}`}>
                {st === "done" ? <Check className="h-3.5 w-3.5" /> : st === "skipped" ? <Minus className="h-3.5 w-3.5" /> : i + 1}
              </span>
              <span className="flex-1">{s.title}</span>
              {s.optional && !compact && <span className="text-[10px] uppercase text-slate-400">{st === "skipped" ? "skipped" : "optional"}</span>}
            </>
          );
          const cls = `flex w-full items-center gap-3 rounded-lg px-2 py-1.5 text-left text-sm transition-colors ${active === i ? "bg-emerald-50 font-semibold text-[#00A85C]" : "text-slate-600 hover:bg-slate-50"}`;
          return (
            <li key={s.key}>
              {onSelect ? <button type="button" onClick={() => onSelect(i)} className={cls} data-testid={`checklist-step-${s.key}`}>{inner}</button>
                : <Link to={`/app/onboarding?step=${s.key}`} className={cls} data-testid={`checklist-step-${s.key}`}>{inner}</Link>}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
